(function() {
  'use strict';

  var runtimeScript = document.currentScript || document.querySelector('script[data-ff-carousel-runtime]');

  function debounce(fn, delay) {
    var timerId;
    return function() {
      clearTimeout(timerId);
      timerId = setTimeout(fn, delay);
    };
  }

  function loadStyle(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function(resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    var existing = document.querySelector('script[src="' + src + '"]');
    if (existing) {
      if (existing.dataset.loaded === 'true') return Promise.resolve();
      return new Promise(function(resolve) {
        existing.addEventListener('load', resolve, { once: true });
      });
    }

    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function() {
        script.dataset.loaded = 'true';
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  var PREV_ARROW_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 18l-6-6 6-6"></path></svg>';
  var NEXT_ARROW_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"></path></svg>';
  var carouselDependenciesPromise;

  function loadCarouselDependencies() {
    if (carouselDependenciesPromise) return carouselDependenciesPromise;
    if (!runtimeScript) return Promise.reject(new Error('Carousel runtime configuration is unavailable.'));
    var jquerySrc = runtimeScript.dataset.jquerySrc;
    var slickJsSrc = runtimeScript.dataset.slickJsSrc;
    var slickCssSrc = runtimeScript.dataset.slickCssSrc;
    var slickThemeCssSrc = runtimeScript.dataset.slickThemeCssSrc;
    var jqueryPromise = window.jQuery ? Promise.resolve() : loadScript(jquerySrc);

    carouselDependenciesPromise = jqueryPromise
      .then(function() {
        return Promise.all([
          loadStyle(slickCssSrc),
          loadStyle(slickThemeCssSrc),
          window.jQuery && window.jQuery.fn && window.jQuery.fn.slick ? Promise.resolve() : loadScript(slickJsSrc)
        ]);
      })
      .then(function() {
        return window.jQuery;
      });

    return carouselDependenciesPromise;
  }

  function initReviewSliders($, reducedMotion) {
    $('.reviews-grid:not(.slick-initialized)').each(function() {
      $(this).slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: reducedMotion ? 0 : 400,
        slidesToShow: 4,
        slidesToScroll: 4,
        centerMode: false,
        adaptiveHeight: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous reviews">' + PREV_ARROW_SVG + '</button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next reviews">' + NEXT_ARROW_SVG + '</button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              centerMode: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              centerMode: true
            }
          },
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true
            }
          }
        ]
      });
    });

    $('.review_group-collection').each(function() {
      var $carousel = $(this);
      var isInitialized = $carousel.hasClass('slick-initialized');
      if (window.innerWidth <= 1300 && !isInitialized) {
        $carousel.slick({
          dots: true,
          arrows: false,
          infinite: false,
          speed: reducedMotion ? 0 : 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '20px'
        });
      } else if (window.innerWidth > 1300 && isInitialized) {
        $carousel.slick('unslick');
      }
    });
  }

  function initHowWeHelpSliders($, reducedMotion) {
    $('.how-we-help-carousel').each(function() {
      var $carousel = $(this);
      var isInitialized = $carousel.hasClass('slick-initialized');

      if (window.innerWidth <= 1024 && !isInitialized) {
        $carousel.slick({
          dots: true,
          arrows: true,
          infinite: false,
          speed: reducedMotion ? 0 : 400,
          slidesToShow: 2,
          slidesToScroll: 1,
          adaptiveHeight: true,
          prevArrow: '<button type="button" class="slick-prev" aria-label="Previous solution">' + PREV_ARROW_SVG + '</button>',
          nextArrow: '<button type="button" class="slick-next" aria-label="Next solution">' + NEXT_ARROW_SVG + '</button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      } else if (window.innerWidth > 1024 && isInitialized) {
        $carousel.slick('unslick');
      }
    });
  }

  function initCarouselRuntime() {
    if (!document.querySelector('.reviews-grid, .review_group-collection, .how-we-help-carousel')) return;

    loadCarouselDependencies()
      .then(function($) {
        if (!$ || !$.fn || !$.fn.slick) return;
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var updateCarousels = function() {
          initReviewSliders($, reducedMotion);
          initHowWeHelpSliders($, reducedMotion);
        };

        updateCarousels();
        window.addEventListener('resize', debounce(updateCarousels, 200));
      })
      .catch(function() {
        /* Static grid remains usable when an optional carousel dependency fails. */
      });
  }

  function disableMobileAffiliateFlickity() {
    if (window.innerWidth > 640) return;

    var sections = document.querySelectorAll('.affiliate_image-text .text-with-icons.flickity-enabled');
    sections.forEach(function(section) {
      if (window.Flickity && typeof window.Flickity.data === 'function') {
        var flickityInstance = window.Flickity.data(section);
        if (flickityInstance) {
          flickityInstance.destroy();
        }
      }

      section.classList.remove('flickity-enabled', 'is-draggable');
      section.removeAttribute('tabindex');

      var viewport = section.querySelector('.flickity-viewport');
      var slider = section.querySelector('.flickity-slider');
      if (viewport && slider) {
        section.innerHTML = slider.innerHTML;
      }

      section.querySelectorAll('.text-with-icons__item').forEach(function(item) {
        item.removeAttribute('style');
        item.classList.remove('is-selected');
      });
    });
  }

  function init() {
    initCarouselRuntime();
    disableMobileAffiliateFlickity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
